import { render, staticRenderFns } from "./WithdrawalRecord.vue?vue&type=template&id=6dee364e&scoped=true"
import script from "./WithdrawalRecord.vue?vue&type=script&lang=js"
export * from "./WithdrawalRecord.vue?vue&type=script&lang=js"
import style0 from "./WithdrawalRecord.vue?vue&type=style&index=0&id=6dee364e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dee364e",
  null
  
)

export default component.exports